"use strict";

var _toConsumableArray = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var mobx_state_tree_1 = require("mobx-state-tree");
var index_1 = require("./index");
var mst_1 = require("./types/mst");
var calculateDynamicBlocks_1 = __importDefault(require("./calculateDynamicBlocks"));
var calculateStaticBlocks_1 = __importDefault(require("./calculateStaticBlocks"));
var Base1DUtils_1 = require("./Base1DUtils");
/**
 * #stateModel Base1DView
 * used in non-lgv view representations of a 1d view e.g. the two axes of the
 * dotplot use this
 */
function x() {} // eslint-disable-line @typescript-eslint/no-unused-vars
var Base1DView = mobx_state_tree_1.types.model('Base1DView', {
  /**
   * #property
   */
  id: mst_1.ElementId,
  /**
   * #property
   */
  displayedRegions: mobx_state_tree_1.types.array(mst_1.Region),
  /**
   * #property
   */
  bpPerPx: 0,
  /**
   * #property
   */
  offsetPx: 0,
  /**
   * #property
   */
  interRegionPaddingWidth: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.number, 0),
  /**
   * #property
   */
  minimumBlockWidth: mobx_state_tree_1.types.optional(mobx_state_tree_1.types.number, 0)
}).volatile(function () {
  return {
    features: undefined,
    volatileWidth: 0
  };
}).actions(function (self) {
  return {
    /**
     * #action
     */
    setDisplayedRegions: function setDisplayedRegions(regions) {
      self.displayedRegions = (0, mobx_state_tree_1.cast)(regions);
    },
    /**
     * #action
     */
    setBpPerPx: function setBpPerPx(val) {
      self.bpPerPx = val;
    },
    /**
     * #action
     */
    setVolatileWidth: function setVolatileWidth(width) {
      self.volatileWidth = width;
    }
  };
}).views(function (self) {
  return {
    /**
     * #getter
     */
    get width() {
      return self.volatileWidth;
    },
    /**
     * #getter
     */
    get assemblyNames() {
      return _toConsumableArray(new Set(self.displayedRegions.map(function (region) {
        return region.assemblyName;
      })));
    },
    /**
     * #getter
     */
    get displayedRegionsTotalPx() {
      return this.totalBp / self.bpPerPx;
    },
    /**
     * #getter
     */
    get maxOffset() {
      // objectively determined to keep the linear genome on the main screen
      var leftPadding = 10;
      return this.displayedRegionsTotalPx - leftPadding;
    },
    /**
     * #getter
     */
    get minOffset() {
      // objectively determined to keep the linear genome on the main screen
      var rightPadding = 30;
      return -this.width + rightPadding;
    },
    /**
     * #getter
     */
    get totalBp() {
      return self.displayedRegions.map(function (a) {
        return a.end - a.start;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    }
  };
}).views(function (self) {
  return {
    /**
     * #getter
     */
    get dynamicBlocks() {
      return (0, calculateDynamicBlocks_1.default)(self);
    },
    /**
     * #getter
     */
    get staticBlocks() {
      return (0, calculateStaticBlocks_1.default)(self);
    },
    /**
     * #getter
     */
    get currBp() {
      return this.dynamicBlocks.map(function (a) {
        return a.end - a.start;
      }).reduce(function (a, b) {
        return a + b;
      }, 0);
    }
  };
}).views(function (self) {
  return {
    /**
     * #method
     */
    pxToBp: function pxToBp(px) {
      return (0, Base1DUtils_1.pxToBp)(self, px);
    },
    /**
     * #method
     */
    bpToPx: function bpToPx(_ref) {
      var refName = _ref.refName,
        coord = _ref.coord,
        regionNumber = _ref.regionNumber;
      var _a;
      return (_a = (0, Base1DUtils_1.bpToPx)({
        refName: refName,
        coord: coord,
        regionNumber: regionNumber,
        self: self
      })) === null || _a === void 0 ? void 0 : _a.offsetPx;
    }
  };
}).actions(function (self) {
  return {
    /**
     * #action
     */
    setFeatures: function setFeatures(features) {
      self.features = features;
    },
    /**
     * #action
     * this makes a zoomed out view that shows all displayedRegions that makes
     * the overview bar square with the scale bar
     */
    showAllRegions: function showAllRegions() {
      self.bpPerPx = self.totalBp / self.width;
      self.offsetPx = 0;
    },
    /**
     * #action
     */
    zoomOut: function zoomOut() {
      this.zoomTo(self.bpPerPx * 2);
    },
    /**
     * #action
     */
    zoomIn: function zoomIn() {
      this.zoomTo(self.bpPerPx / 2);
    },
    /**
     * #action
     */
    zoomTo: function zoomTo(newBpPerPx) {
      var offset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : self.width / 2;
      var bpPerPx = newBpPerPx;
      if (bpPerPx === self.bpPerPx) {
        return self.bpPerPx;
      }
      var oldBpPerPx = self.bpPerPx;
      self.bpPerPx = bpPerPx;
      // tweak the offset so that the center of the view remains at the same coordinate
      self.offsetPx = (0, index_1.clamp)(Math.round((self.offsetPx + offset) * oldBpPerPx / bpPerPx - offset), self.minOffset, self.maxOffset);
      return self.bpPerPx;
    },
    /**
     * #action
     */
    scrollTo: function scrollTo(offsetPx) {
      var newOffsetPx = (0, index_1.clamp)(offsetPx, self.minOffset, self.maxOffset);
      self.offsetPx = newOffsetPx;
      return newOffsetPx;
    },
    /**
     * #action
     */
    centerAt: function centerAt(coord, refName, regionNumber) {
      if (!refName) {
        return;
      }
      var centerPx = self.bpToPx({
        refName: refName,
        coord: coord,
        regionNumber: regionNumber
      });
      if (centerPx) {
        this.scrollTo(Math.round(centerPx - self.width / 2));
      }
    },
    /**
     * #action
     * note: the scroll is clamped to keep the view on the main screen
     */
    scroll: function scroll(distance) {
      var oldOffsetPx = self.offsetPx;
      var newOffsetPx = (0, index_1.clamp)(self.offsetPx + distance, self.minOffset, self.maxOffset);
      self.offsetPx = newOffsetPx;
      return newOffsetPx - oldOffsetPx;
    }
  };
}).actions(function (self) {
  return {
    /**
     * #action
     * offset is the base-pair-offset in the displayed region, index is the index of the
     * displayed region in the linear genome view
     *
     * @param start - object as `{start, end, offset, index}`
     * @param end - object as `{start, end, offset, index}`
     */
    moveTo: function moveTo(start, end) {
      (0, Base1DUtils_1.moveTo)(self, start, end);
    }
  };
});
exports.default = Base1DView;